export const markerStateForEdge = (edgeId, blockedEdges, oneWayEdges) => {
    const blocked = Array.isArray(blockedEdges) && blockedEdges.some((edge) => {
        if (typeof edge === 'string') {
            return edge === edgeId;
        }
        return Array.isArray(edge) && edge.join('-') === edgeId;
    });
    if (blocked) {
        return { state: 'blocked', direction: null };
    }

    const direction = Array.isArray(oneWayEdges)
        ? oneWayEdges.find((edge) => edge?.edge_id === edgeId)
        : null;
    if (direction) {
        return {
            state: 'one-way',
            direction: {
                from: direction.from,
                to: direction.to,
            },
        };
    }

    return { state: 'normal', direction: null };
};

export const markerRotation = (marker, markerState) => {
    const base = Number(marker?.rotation);
    const rotation = Number.isFinite(base) ? base : 0;
    if (markerState?.state !== 'one-way') {
        return rotation;
    }

    return markerState.direction?.from === marker?.start
        && markerState.direction?.to === marker?.end
        ? rotation
        : rotation + 180;
};

export const groupMarkersByEdge = (markers) => {
    const grouped = new Map();
    (Array.isArray(markers) ? markers : []).forEach((marker) => {
        if (!marker?.edgeId) {
            return;
        }
        if (!grouped.has(marker.edgeId)) {
            grouped.set(marker.edgeId, []);
        }
        grouped.get(marker.edgeId).push(marker);
    });
    return grouped;
};
